import React, { useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import userService from '../../services/user.service';
import { toastOptions } from '../shared/selectStyle';
import validateEmail from '../shared/validateEmail';

const CompanyMember = (props) => {
    const { t } = useTranslation();
    const initialMemeber = {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        companyId: props.companyId,
        code: props.code
    }

    const [error, setError] = useState(false);
    const [invalidEmail, setInvalidEmail] = useState(false);
    const [invalidPassword, setInvalidPasword] = useState(false);
    const memeberForm = useRef(null)
    const [companyMember, setCompanyMember] = useState(initialMemeber);

    const handleChange = (event) => {
        setError(false);
        setInvalidEmail(false);
        setInvalidPasword(false);
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        setCompanyMember({
            ...companyMember,
            [name]: value.trim()
        });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validateForm()) {
            await userService.register(companyMember)
            toast.success("Memeber is successfully added!", toastOptions);
            memeberForm.current.reset();
            setCompanyMember({
                ...initialMemeber
            });
            props.isChanged();
        }
    }

    const validateForm = () => {
        if (companyMember.email) {
            if (!validateEmail(companyMember.email)) {
                setInvalidEmail(true)
                return false
            }
        }
        let isValid = companyMember.password && companyMember.email && companyMember.email && companyMember.firstName && companyMember.lastName;
        if (!isValid) {
            setError(true);
            return isValid;
        };
        if (companyMember.password.length < 4) {
            setInvalidPasword(true);
            return false;
        }
        return isValid;
    }

    return (
        <div>
            <h4 className="h4-title mt-5 mb-0">{t('company.memeber.create.title')}</h4>
            <form onSubmit={handleSubmit} className="form-sm" ref={memeberForm} >
                <div className="form-group custom-input">
                    <input id='firstname' className="form-control" type="text" name="firstName" onChange={handleChange} placeholder={t('placeholder.firstname')} />
                </div>
                <div className="form-group custom-input">
                    <input id='lastName' className="form-control" type="text" name="lastName" onChange={handleChange} placeholder={t('placeholder.lastname')} />
                </div>
                <div className="form-group custom-input">
                    <input id="email" className="form-control" type="text" name="email" onChange={handleChange} placeholder={t('placeholder.email')} />
                </div>
                <div className="form-group custom-input">
                    <input id="password" className="form-control" type="password" name="password" onChange={handleChange} placeholder="•••••••" />
                </div>
                {error ? <div className="message-alert"><p>{t('requiredFields.msg')}</p></div> : null}
                {invalidEmail ? <div className="message-alert"><p>Please enter valid email address!</p></div> : null}
                {invalidPassword ? <div className="message-alert"><p>Password needs to be longer than 3 characters!</p></div> : null}

                <button className="btn btn-blue">{t('create')}</button>
            </form>
        </div>
    );
}

export default CompanyMember;



// WEBPACK FOOTER //
// ./src/components/companyComponent/companyMember.js